import { render, staticRenderFns } from "./SearchByCategory.vue?vue&type=template&id=8faf322a&scoped=true&"
import script from "./SearchByCategory.vue?vue&type=script&lang=js&"
export * from "./SearchByCategory.vue?vue&type=script&lang=js&"
import style0 from "./SearchByCategory.vue?vue&type=style&index=0&id=8faf322a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faf322a",
  null
  
)

export default component.exports